import {
  HStack,
  Image,
  Text,
  UseDisclosureReturn,
  VStack,
} from '@chakra-ui/react';
import { format } from 'date-fns';
import { PrizeTicket } from '~/types/resources/prizeTicket';
import {
  DialogBackdrop,
  DialogBody,
  DialogContent,
  DialogHeader,
  DialogRoot,
} from '../ui/dialog';

type Props = {
  unAvailableTickets: PrizeTicket[];
  usedTicketsDisclosure: UseDisclosureReturn;
};

const dateFormatter = (dateString: string) => {
  const date = new Date(dateString);
  return format(date, "yyyy年M月d日' 'HH時mm分");
};

export const PrizeTicketUnAvailableModal: React.FC<Props> = (props: Props) => {
  return (
    <DialogRoot
      open={props.usedTicketsDisclosure.open}
      onInteractOutside={props.usedTicketsDisclosure.onClose}
      scrollBehavior="inside"
    >
      <DialogBackdrop />
      <DialogContent>
        <DialogHeader p="8px">
          <HStack w="full" justify="space-between" align="center">
            <Text fontSize="16px" fontWeight="bold">
              使用済みのチケット・クーポン一覧
            </Text>
            <Image
              src="/assets/icon/close.svg"
              alt="icon"
              h="28px"
              w="28px"
              onClick={props.usedTicketsDisclosure.onClose}
            />
          </HStack>
        </DialogHeader>
        <DialogBody>
          {Object.values(props.unAvailableTickets).map((ticket, index) => {
            return (
              <HStack key={index} mb="10px">
                <Image
                  boxSize="70px"
                  h="full"
                  src={ticket.thumbnail_url}
                  alt={`${ticket.name}の画像`}
                  loading="lazy"
                  pointerEvents="none"
                />
                <VStack align="flex-start" gap="0">
                  <Text fontSize="12px" fontWeight="bold">
                    {ticket.name}
                  </Text>
                  <Text fontSize="10px">
                    使用日時：
                    {ticket.used_at
                      ? dateFormatter(ticket.used_at)
                      : ticket.expired_at
                        ? `${dateFormatter(ticket.expired_at)} 失効`
                        : ''}
                  </Text>
                  <Text fontSize="10px">
                    シリアルナンバー：{ticket.serial_code}
                  </Text>
                </VStack>
              </HStack>
            );
          })}
        </DialogBody>
      </DialogContent>
    </DialogRoot>
  );
};
